export enum LanguageProps  {
    'Svenska'=1,
    'English'=2
  }
  export default LanguageProps;